import React, { useState, useEffect } from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPICostSet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState();
    const [localAcceptedFilterModel, setLocalAcceptedFilterModel] = useState();
    const { getComparableTimeframe } = useDates();

    useEffect(() => {
        if (!filterModel) return;
        const localAcceptedFilterModel = { items: [...filterModel.items, { field: "status", operator: "equals", value: "accepted" }] }
        setLocalAcceptedFilterModel(localAcceptedFilterModel);
        setLocalDrawable(true);
    }, [filterModel])

    return (localDrawable &&
        <Box className="mtska-kpi-set" sx={{ marginBottom: '0px', gap: '80px' }}>
            <KPI
                title="CPL | Costo lead"
                dataProviderName={'statisticsviews/item/costperunit/opportunities/lead'}
                filters={filterModel}
                format='currency'
                compactformat={false}
                decimaldigits={'standard'}
                compareFilters={getComparableTimeframe(filterModel, 'registered_at')}
                comparePositiveCondition={'inverse'}
                className='mtska-chart-kpi-short'
            />
            <KPI
                title="CPP | Costo proposta"
                dataProviderName={'statisticsviews/item/costperunit/opportunities/proposal'}
                filters={filterModel}
                format='currency'
                compactformat={false}
                decimaldigits={'standard'}
                compareFilters={getComparableTimeframe(filterModel, 'registered_at')}
                comparePositiveCondition={'inverse'}
                className='mtska-chart-kpi-short'
            />
            <KPI
                title="CPA | Costo accettata"
                dataProviderName={'statisticsviews/item/costperunit/opportunities/proposal'}
                filters={localAcceptedFilterModel}
                format='currency'
                compactformat={false}
                decimaldigits={'standard'}
                compareFilters={getComparableTimeframe(localAcceptedFilterModel, 'registered_at')}
                comparePositiveCondition={'inverse'}
                className='mtska-chart-kpi-short'
            />
        </Box>
    )
}

export default KPICostSet;